import {
  SocialPlatformSchema,
  TaskSchema,
  TaskStatusSchema,
  TaskTypeConfigSchema,
  TaskTypeSchema,
  type Task,
  type TaskStatus,
} from "@coso/core/prisma/zod";
import type { Handler } from "aws-lambda";
import { z } from "zod";

export {
  Task,
  TaskSchema,
  TaskStatus,
  TaskStatusSchema,
  TaskTypeConfigSchema,
  TaskTypeSchema,
};

const LambdaRunnerSchema = z.object({
  type: z.literal("lambda"),
  layers: z.enum(["chromium"]).array().optional(),
  timeout: z.number().optional(),
  architecture: z.enum(["x86_64", "arm64"]).optional(),
  runtime: z.enum(["nodejs18.x", "nodejs20.x"]).optional(),
});

const LocalRunnerSchema = z.object({
  type: z.literal("local"),
  handler: z.custom<Handler>(),
});

export const PluginConfigSchema = TaskTypeSchema.omit({ id: true }).extend({
  runner: z
    .discriminatedUnion("type", [LambdaRunnerSchema, LocalRunnerSchema])
    .optional(),
});

export type PluginConfigSchema = z.infer<typeof PluginConfigSchema>;

export const WorkflowEventDetails = z.object({
  type: z.literal("workflow.run"),
  userId: z.string().optional(),
  brandId: z.string(),
  workflowId: z.string(),
  data: z.object({
    startTask: z.string(),
    stopTask: z.string().optional(),
    datetime: z.coerce.date().optional(),
    debug: z.boolean().optional(),
  }),
});

export type WorkflowEventDetails = z.infer<typeof WorkflowEventDetails>;

export const TaskOutput = z.object({
  url: z.string().url().optional(),
  title: z.string().optional(),
  description: z.string().optional(),
  text: z.string().optional(),
  image_prompt: z.string().optional(),
  images: z.string().array().optional(),
  platforms: SocialPlatformSchema.array().optional(),
  time: z.object({ hour: z.number(), minute: z.number() }).optional(),
  datetime: z.coerce.date().optional(),
  post: z.any().optional(),
  image_template: z
    .object({
      template: z.any(),
    })
    .optional(),
  text_template: z.string().optional(),
  memory: z
    .record(
      z.object({
        id: z.string().optional(),
        data: z.string().optional(),
        type: z.enum(["json", "url", "string"]).optional(),
        name: z.string().optional(),
      })
    )
    .default({})
    .optional(),
});

export type TaskOutput = z.infer<typeof TaskOutput>;
